import * as React from "react";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import styled, { css } from "styled-components";
import camelCase from "lodash/camelCase";
import upperCase from "lodash/upperCase";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import FilterRuleForm from "components/streams/StreamDetails/output-filter/FilterRuleForm";
import useStreamOutputRuleMutation from "components/streams/hooks/useStreamOutputRuleMutation";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const StyledButton = styled(Button)(
  ({ theme }) => css`
    margin: 0 ${theme.spacings.xxs};
  `
);
const FilterRuleEditButton = ({ streamId, filterRule, destinationType }) => {
  const [showForm, setShowForm] = useState(false);
  const { createStreamOutputRule, updateStreamOutputRule } = useStreamOutputRuleMutation();
  const sendTelemetry = useSendTelemetry();
  const queryClient = useQueryClient();
  const isNew = !(filterRule == null ? void 0 : filterRule.id);
  const onClick = () => {
    setShowForm(true);
    sendTelemetry(
      TELEMETRY_EVENT_TYPE.STREAMS[`STREAM_ITEM_DATA_ROUTING_${upperCase(camelCase(destinationType))}_FILTER_${isNew ? "CREATE_OPENED" : "UPDATE_OPENED"}`],
      {
        app_pathname: "streams"
      }
    );
  };
  const handleSubmit = (filterOutputRule) => {
    const submitFilterHandler = isNew ? createStreamOutputRule : updateStreamOutputRule;
    submitFilterHandler({ streamId, filterOutputRule }).then(() => {
      queryClient.invalidateQueries({
        queryKey: ["streams"]
      });
      setShowForm(false);
    });
  };
  const title = isNew ? "Create Filter Rule" : "Edit Filter Rule";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: isNew ? "default" : "default", bsSize: isNew ? "sm" : "xs", onClick, title: "Edit" }, isNew ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "sm" }), " Create rule") : /* @__PURE__ */ React.createElement(Icon, { name: "edit_square" })), showForm && /* @__PURE__ */ React.createElement(
    FilterRuleForm,
    {
      title,
      filterRule,
      destinationType,
      onCancel: () => setShowForm(false),
      handleSubmit
    }
  ));
};
export default FilterRuleEditButton;
